// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MentionsPlaceholder__container-be5bec {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  padding: 5px 16px;
  max-width: var(--max-width-input-top-panel);
  width: 100%;
}

.MentionsPlaceholder__content-f54dd0 {
  margin-inline-start: 8px;
}

.MentionsPlaceholder__first-line-b5841e {
  margin-bottom: 4px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/MentionsPlaceholder/MentionsPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0 auto;\n  padding: 5px 16px;\n  max-width: var(--max-width-input-top-panel);\n  width: 100%;\n}\n\n.content {\n  margin-inline-start: 8px;\n}\n\n.first-line {\n  margin-bottom: 4px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MentionsPlaceholder__container-be5bec`,
	"content": `MentionsPlaceholder__content-f54dd0`,
	"first-line": `MentionsPlaceholder__first-line-b5841e`,
	"firstLine": `MentionsPlaceholder__first-line-b5841e`
};
module.exports = ___CSS_LOADER_EXPORT___;
